export default navigator.userAgent;

export const isIE = !!navigator.userAgent.match(/Trident.*rv:11\./);
